import { useState } from 'react';
import { CONFIG, api } from './_barrel.js';


        // ===== Edit Subject =====
        // ===== Subject Photo Uploader =====
        // Compact uploader for the optional portrait that appears on
        // the PDF cover. 2MB cap; JPEG or PNG only.
        function SubjectPhotoUploader({ subject, token }) {
            const [hasPhoto, setHasPhoto] = useState(!!subject.photo_uploaded_at);
            const [uploading, setUploading] = useState(false);
            const [error, setError] = useState(null);
            const [success, setSuccess] = useState(null);
            const [previewKey, setPreviewKey] = useState(Date.now());

            const photoUrl = `${CONFIG.apiBase}/api/v1/subjects/${subject.id}/photo?access_token=${encodeURIComponent(token || '')}&k=${previewKey}`;

            const handleUpload = async (e) => {
                const f = e.target.files[0];
                if (!f) return;
                if (f.size > 2 * 1024 * 1024) {
                    setError(`Photo too large (${(f.size/1024/1024).toFixed(1)}MB). Max 2MB.`);
                    setSuccess(null);
                    return;
                }
                if (!['image/jpeg','image/jpg','image/png'].includes(f.type)) {
                    setError(`Unsupported file type ${f.type}. JPEG or PNG only.`);
                    setSuccess(null);
                    return;
                }
                setUploading(true); setError(null); setSuccess(null);
                try {
                    const fd = new FormData();
                    fd.append('file', f);
                    const resp = await fetch(`${CONFIG.apiBase}/api/v1/subjects/${subject.id}/photo`, {
                        method: 'POST',
                        headers: { 'Authorization': `Bearer ${token}` },
                        body: fd,
                    });
                    if (!resp.ok) {
                        const txt = await resp.text();
                        throw new Error(`Upload failed: ${resp.status} ${txt.slice(0,200)}`);
                    }
                    setHasPhoto(true);
                    setPreviewKey(Date.now());  // cache-bust the preview img
                    setSuccess(`Uploaded ${f.name} (${(f.size/1024).toFixed(0)} KB)`);
                    // Clear the success message after 4 seconds so it doesn't linger
                    setTimeout(() => setSuccess(null), 4000);
                    // Reset the file input so the same file can be re-uploaded if needed
                    e.target.value = '';
                } catch (err) {
                    setError(err.message);
                } finally {
                    setUploading(false);
                }
            };

            const handleDelete = async () => {
                if (!confirm('Remove this subject photo?')) return;
                setError(null); setSuccess(null);
                try {
                    await fetch(`${CONFIG.apiBase}/api/v1/subjects/${subject.id}/photo`, {
                        method: 'DELETE',
                        headers: { 'Authorization': `Bearer ${token}` },
                    });
                    setHasPhoto(false);
                    setSuccess('Photo removed.');
                    setTimeout(() => setSuccess(null), 3000);
                } catch (err) {
                    setError(err.message);
                }
            };

            return (
                <div className="space-y-3">
                    <div className="font-mono text-xs uppercase tracking-widest gold">Cover Photo (optional)</div>
                    <div className="flex items-center gap-4">
                        {hasPhoto ? (
                            <img
                                src={photoUrl}
                                alt="subject"
                                style={{width: '80px', height: '80px', objectFit: 'cover', border: '1px solid var(--gold)'}}
                            />
                        ) : (
                            <div
                                style={{width: '80px', height: '80px', border: '1px dashed var(--muted)', display:'flex', alignItems:'center', justifyContent:'center'}}
                                className="text-xs text-muted font-mono"
                            >
                                no photo
                            </div>
                        )}
                        <div className="flex flex-col gap-2">
                            <label className="btn-ghost cursor-pointer" style={{textAlign:'center'}}>
                                {uploading ? 'Uploading…' : (hasPhoto ? 'Replace photo' : 'Upload photo')}
                                <input type="file" accept="image/jpeg,image/png" style={{display:'none'}} onChange={handleUpload} disabled={uploading} />
                            </label>
                            {hasPhoto && (
                                <button type="button" className="btn-ghost text-xs" onClick={handleDelete}>
                                    Remove photo
                                </button>
                            )}
                        </div>
                    </div>
                    {success && <div className="text-xs" style={{color: 'var(--gold)'}}>✓ {success}</div>}
                    {error && <div className="text-xs" style={{color: 'var(--red)'}}>{error}</div>}
                    <div className="text-xs text-muted font-mono">
                        JPEG or PNG, max 2MB. Appears on the PDF cover.
                    </div>
                </div>
            );
        }

export { SubjectPhotoUploader };
